import { render, staticRenderFns } from "./struktur.vue?vue&type=template&id=70645a91"
import script from "./struktur.vue?vue&type=script&lang=js"
export * from "./struktur.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports